import React from 'react';

import { useAppDispatch } from '@pkg/hooks';

import { collectionPageActions, detailViewActions, wishlistActions } from '@app/store/slices';

import { Button, Wrapper } from './styles';

export const MobileCloseButton = () => {
    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(detailViewActions.setShowActivitySidebar(false));
        dispatch(collectionPageActions.setShowActivitySidebar(false));
        dispatch(wishlistActions.setShowActivitySidebar(false));
    };

    return (
        <Wrapper>
            <Button onClick={handleClick}>Close</Button>
        </Wrapper>
    );
};
